var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('v-tabs',{staticClass:"elevation-2",attrs:{"background-color":"accent-4"}},[_c('v-tab',[_vm._v("Dashboarders")]),_c('v-tab',[_vm._v("Receipts")]),_c('v-tab-item',[_c('DashboarderStats')],1),_c('v-tab-item',[_c('ReceiptStats')],1)],1):_c('div',[_c('DashboarderStats')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }